/* Estrani - maatknoppen die minder plaats innemen. Door Claude gebouwd,
   veilig te verwijderen: haal de regels voor ai-maatknoppen uit
   snippets/ai-hoofd.liquid en gooi dit bestand en ai-maatknoppen.css weg.

   Wat er mis was. Het thema zet de maatknoppen in een raster dat rekent met
   het BREEDSTE label. Bij kleren is dat "3XL" (56,8px) en passen er vijf naast
   elkaar: zes maten vielen dus over twee regels, met "3XL" alleen op de
   tweede. Bij schoenen is het label "EU 39" (77,6px) en passen er maar drie:
   elf maten werden vier regels van 275px hoog.

   Wat dit doet. Twee dingen, en alleen in beeld - aan de productgegevens
   verandert niets.

   1. Staat er bij ELKE maat "EU" voor het getal, dan tonen we enkel het getal.
      De waarde in het formulier en de aria-label blijven "EU 39", dus de
      winkelwagen, de bestelling en een schermlezer zien de volle naam. Naast
      het woord Maat komt er een keer "EU-maten" te staan, zodat de uitleg
      niet verdwijnt.

   2. Zijn alle labels daarna kort (vier tekens of minder), dan krijgt het veld
      de klasse ai-maat-kort en zet ai-maatknoppen.css er een raster van 44px
      op. Gemeten op een kolom van 343px: zes kolommen in plaats van vijf of
      drie.

   Een kleurveld met tekstknoppen raken we niet aan: "Marineblauw" is langer
   dan vier tekens, dus zo'n veld krijgt de klasse niet en blijft staan zoals
   het thema het zet. De fotostaaltjes (ai-kf-veld) slaan we expliciet over.

   Waarom een kijker en niet een keer lopen: het thema hertekent de
   keuzeknoppen bij elke variantwissel, en het snelkoopvenster bouwt ze pas
   als het opengaat. */

(function () {
  'use strict';
  if (window.__aiMaatknoppen) return;
  window.__aiMaatknoppen = true;

  var BEZIG = false;
  var EU = /^\s*EU\s*\d+\s*$/i;

  function doeVeld(veld) {
    /* Fotostaaltjes hebben hun eigen opmaak in ai-kleurfotos.css. */
    if (veld.classList.contains('ai-kf-veld')) return;
    var teksten = veld.querySelectorAll('.variant-option__button-label__text');
    if (teksten.length < 2) return;
    /* Merk meteen af, zodat onze eigen wijzigingen hieronder de kijker niet
       opnieuw op dit veld laten lopen. */
    veld.dataset.aiMaat = '1';

    var i;
    var allemaalEu = true;
    for (i = 0; i < teksten.length; i++) {
      if (!EU.test(teksten[i].textContent)) { allemaalEu = false; break; }
    }

    if (allemaalEu) {
      for (i = 0; i < teksten.length; i++) {
        teksten[i].textContent = teksten[i].textContent.replace(/^\s*EU\s*/i, '').trim();
      }
      var lg = veld.querySelector('legend');
      if (lg && !lg.querySelector('.ai-mk__eu')) {
        var hint = document.createElement('span');
        hint.className = 'ai-mk__eu';
        hint.textContent = 'EU-maten';
        lg.appendChild(hint);
      }
    }

    var kort = true;
    for (i = 0; i < teksten.length; i++) {
      if (teksten[i].textContent.trim().length > 4) { kort = false; break; }
    }
    if (kort) veld.classList.add('ai-maat-kort');
  }

  function draai() {
    if (BEZIG) return;
    BEZIG = true;
    try {
      var velden = document.querySelectorAll(
        'fieldset.variant-option--buttons:not([data-ai-maat])'
      );
      for (var i = 0; i < velden.length; i++) doeVeld(velden[i]);
    } catch (e) { /* nooit de pagina breken */ }
    BEZIG = false;
  }

  draai();
  new MutationObserver(draai).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', draai, { once: true });
  }
})();
